<div class="persona-picker-container" *ngIf="ready">
  <div class="persona-picker-header">
    <div class="persona-picker-welcome">Welcome Back, {{ selfPersona.first_name }}!</div>
    <h2 *ngIf="header" class="persona-picker-title">{{ header }}</h2>
  </div>
  <se-po-persona-picker #picker
    (pick)="onPick($event)"
    (edit)="onEdit($event)"
    (action)="onAction($event)"
    (editMissingInfo)="onEditMissingInfo($event)"
    [profiles]="managedProfiles"
    [profilesFrames]="userProfilesFrames"
  ></se-po-persona-picker>

  <div class="add-profile-btn" *ngIf="!excludeManagedProfiles && permissions.selfIsAdult">
    <se-fe-chip
      seFeDataText="Add new child"
      seFeDataIconLeft="plus_circle_outline"
      seFeDataStyle="primary"
      (seFeClick)="onAddProfileClick($event)"
    ></se-fe-chip>
  </div>
</div>
<se-po-add-profile-modal #addProfileModal
  [selfPersona]="selfPersona"
  [userId]="userId"
  (addedProfile)="onAddProfile($event)"
  (modalClosed)="onAddProfileClose()">
</se-po-add-profile-modal>

<se-po-edit-persona-modal #editPersonaModal
  [showContactInfo]="editInfoProfile?.relationship === 'self'"
  [requiredFields]="['gender']"
  (personaEdited)="onPersonaSave()">
</se-po-edit-persona-modal>
<se-po-add-guardian-modal #addGuardianModal
  (modalClosed)="onAddGuardianClose($event)">
</se-po-add-guardian-modal>
<se-fe-toast></se-fe-toast>
